import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import classNames from 'classnames';
import React from 'react';
import { Anchor, Container, MiroLogo, Navbar } from '@miro-site/ui-foundation';
import { UserStatus, useUserStatus } from '@miro-site/utils-helpers';
import { MainMenu } from './components/main-menu';
import { MetaMenu } from './components/meta-menu';
import { MiroDrawer } from './miro-drawer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

/**
 * Miro Header is our main header for the site.
 * It contains the main navigation and the meta menu and a drawer
 * menu for breakpoints below xl.
 *
 * @figma - https://www.figma.com/design/utdKqeub7vsQE8rVa0mB28?node-id=10085-21561&node-type=INSTANCE&m=dev
 */
export var MiroHeaderPresenterV2 = function MiroHeaderPresenterV2(_ref) {
  var metaMenuLinks = _ref.metaMenuLinks,
      skipLinkLabel = _ref.skipLinkLabel,
      menu = _ref.menu,
      _ref$userStatus = _ref.userStatus,
      userStatus = _ref$userStatus === void 0 ? UserStatus.loggedIn : _ref$userStatus;

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isDrawerOpen = _React$useState2[0],
      setIsDrawerOpen = _React$useState2[1];

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Navbar, {
      sticky: "top",
      "data-skip-href": skipLinkLabel || 'Primary Navigation',
      className: "container pt-200 pt-md-300 justify-content-center position-sticky",
      style: {
        /**
         * This z-index is used to counter the z-index that other sticky elements on
         * the page may have.
         */
        zIndex: '1021',

        /**
         * The body line height is set to 1.35 which means the default height of
         * the navbar is 1.35rem. We need to set the line height to 0 to remove
         * the extra space.
         */
        lineHeight: 0
      },
      children: /*#__PURE__*/_jsxs(Container, {
        className: "rounded-150 shadow-50 mx-175 mx-lg-100 p-150 p-md-200 bg-white",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "d-flex gap-150 gap-xl-300",
          children: [/*#__PURE__*/_jsx("span", {
            className: "d-flex d-xl-none align-self-center",
            children: /*#__PURE__*/_jsx(Anchor, {
              className: "fs-3 px-50",
              iconStart: "LinesThreeHorizontal",
              size: "md",
              circularBg: true,
              withHoverBg: true,
              onClick: function onClick() {
                setIsDrawerOpen(!isDrawerOpen);
              }
            })
          }), /*#__PURE__*/_jsx("span", {
            className: classNames('me-auto flex-shrink-0'),
            children: /*#__PURE__*/_jsxs(Anchor, {
              "data-testid": "logo-cta",
              title: "Go to homepage",
              href: "/",
              children: [/*#__PURE__*/_jsx(MiroLogo.Dark, {
                className: "d-block d-md-none icon-size-400",
                width: "87.6px",
                height: "32px"
              }), /*#__PURE__*/_jsx(MiroLogo.Dark, {
                className: "d-none d-md-block",
                width: "109.5px",
                height: "40px"
              })]
            })
          }), /*#__PURE__*/_jsx(MainMenu, {
            menu: menu
          })]
        }), /*#__PURE__*/_jsx("div", {
          className: "d-none d-md-flex gap-200 justify-content-around",
          children: /*#__PURE__*/_jsx(MetaMenu, _objectSpread({
            userStatus: userStatus
          }, metaMenuLinks))
        })]
      })
    }), /*#__PURE__*/_jsx(MiroDrawer, {
      metaMenuLinks: metaMenuLinks,
      menu: menu,
      isOpen: isDrawerOpen,
      setIsOpen: setIsDrawerOpen,
      userStatus: userStatus
    })]
  });
};
export var MiroHeaderV2 = function MiroHeaderV2(props) {
  var userStatus = useUserStatus();
  return /*#__PURE__*/_jsx(MiroHeaderPresenterV2, _objectSpread(_objectSpread({}, props), {}, {
    userStatus: userStatus
  }));
};